// extracted by mini-css-extract-plugin
export const sidebar = "Sidebar-module--sidebar--1NhQN";
export const sidebar__inner = "Sidebar-module--sidebar__inner--KmoRQ";